import axios from "axios";

// Create an Axios instance
const api = axios.create({
  // baseURL: window.location.pathname.split("/")[0],
  baseURL: "http://kirtan1.pcb.click",
  // baseURL: "http://localhost:5200", // Ensure this is defined in your environment config
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ERR_NETWORK") {
      console.error("Network error occurred");
    }

    if (error.code === "ERR_BAD_RESPONSE" && error.response?.data?.message === "Signature verification failed") {
      console.error("Signature verification failed");
    }

    if (error.response?.status === 401 && error.config && !error.config.__isRetryRequest) {
      console.error("Unauthorized access - perhaps redirect to login");
      // remove token from sessionStorage
      // sessionStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const authToken = sessionStorage.getItem("token");
    config.headers = {
      ...config.headers,
      "Content-Type": "application/json",
      Authorization: authToken ? `Bearer ${authToken}` : "",
    };

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
